// Vue
import { Component, Prop, Vue } from "vue-property-decorator";
// Template
import template from "./template.vue";
import { Accordion } from "#/components/accordion/Accordion";
import { Product } from "#/common/interfaces/conversionworld/Product";
import { TextModule } from "#/common/interfaces/conversionworld/TextModule";
import { ProductLink } from "./product_link/ProductLink";

@Component({
  mixins: [template],
  components: {
    Accordion,
    ProductLink,
  },
})
export class ProductList extends Vue {
  private active_el = 1;

  @Prop({ default: () => [] })
  public productsList!: Product[];

  @Prop({ default: () => [] })
  public textModules!: TextModule[];

  @Prop({ default: "" })
  public type!: string;

  @Prop({ default: "default" })
  public theme!: string;

  @Prop({ default: "" })
  public compareLabel!: string;

  @Prop()
  public maximumCompareLabel!: string;

  public activate(el) {
    this.active_el = el;
  }

  public getColMd(product, index, type) {
    if (this.theme === "search") {
      if (type === "van-solution") {
        return 5;
      }

      return 4;
    }

    if (type === "van-solution" || product.position) {
      return 5;
    }

    if (product.highlight) {
      return 6;
    }

    return 4;
  }

  public getColMdOffset(product, index, type) {
    let isRight = index % 2 == 1;

    if (this.theme === "search") {
      if (type === "van-solution") {
        return isRight ? 1 : 0;
      }

      return 0;
    }

    if (type === "van-solution" || product.position) {
      return isRight ? 1 : 0;
    }

    if (product.highlight) {
      return 0;
    }

    return 1;
  }

  public getColMdSuffix(product, index, type) {
    let isRight = index % 2 == 1;

    if (this.theme === "search") {
      if (type === "van-solution") {
        return isRight ? 0 : 1;
      }

      return 0;
    }

    if (type === "van-solution" || product.position) {
      return isRight ? 0 : 1;
    }

    if (product.highlight) {
      return 0;
    }

    return 1;
  }

  public getMarginTopClass(product, index, type) {
    if (this.theme === "search") {
      return "";
    }

    if (index % 2 === 1) {
      return "mar-top-xxxl";
    }

    return "";
  }

  public getColMdSuffixClass(product, index, type) {
    return "wb-col-suffix-mq3-" + this.getColMdSuffix(product, index, type);
  }

  public getProductLink(id, slug) {
    let lang = this.$store.ui.appCurrentLanguage;
    return "/" + lang + "/partner-produkt/" + id + "/" + slug;
  }

  get productsAndTexts() {
    let merge: any[] = [...this.productsList];
    this.textModules.forEach((text) => {
      if (text.position < merge.length) {
        merge.splice(text.position, 0, text);
      }
    });
    return merge;
  }
}
